import { Text, View } from 'react-native';
import React from 'react';
import Modal from "react-native-modal";
import { AntDesign } from "@expo/vector-icons";
import styles from "styles/components/SmsValidationCode";
import { Button } from 'react-native-elements';

const MessageModal = ({ show = false, onClose, message, result = false }: { show: boolean, onClose: any, message: string, result: boolean }) => {

  return (
    <>
      <Modal isVisible={show}>
        <View style={{ backgroundColor: "#fff", borderRadius: 10, padding: 5 }}>
          <View>
            <AntDesign onPress={() => onClose()} style={{ alignSelf: "flex-end" }} name="close" size={32} color="black" />
          </View>

          <View style={styles.iconsContainer}>
            {result ? (
              <AntDesign name="checkcircle" size={60} color={'#0f0'} />
            ) : (
              <AntDesign name="closecircle" size={60} color={'#f00'} />
            )}
          </View>

          <Text style={[styles.invalidCodeMessage,
          { color: result ? '#000' : '#f00' }
          ]}>
            {message}
          </Text>

          <View>
            <Button
            title={result ? 'Realizar otra factura' : 'Probar otro código'}
            type="clear"
            containerStyle={styles.confirmPaymentBtnContainer}
            buttonStyle={[
              styles.confirmPaymentBtn,
              { backgroundColor: "#056EC1" },
            ]}
            titleStyle={[
              styles.confirmPaymentBtnText,
              { color: "#FFF" },
            ]}
            onPress={() => onClose()}
          />
          </View>
        </View>
      </Modal>
    </>
  );
};

export default MessageModal;